import {
  CommonTrackingConfig,
  findTrackingConfig,
  getCustomClickTrackValues,
  mapTrackingProperties,
} from '../../../modules/utils/trackingHelper';

export const WALLET_AWARD_EMPTY_TRACKING_KEYS = {
  FNA: 'fnaEmpty',
  NUA: 'nuaEmpty',
} as const;

const resolveLinkType = (tracking?: CommonTrackingConfig): 'internal' | 'external' => {
  if (tracking?.linkType === 'external' || tracking?.linkType === 'internal') {
    return tracking.linkType;
  }

  return 'internal';
};

const resolveTrackingConfig = (
  tracking?: CommonTrackingConfig | CommonTrackingConfig[],
  keyValue?: string
): CommonTrackingConfig | undefined => {
  if (!tracking) {
    return undefined;
  }

  if (Array.isArray(tracking)) {
    if (keyValue) {
      return findTrackingConfig(tracking, keyValue);
    }

    return tracking[0];
  }

  return tracking;
};

export const resolveWalletEmbeddedTracking = (tracking?: CommonTrackingConfig) => {
  const trackingProperties = mapTrackingProperties(tracking);
  const linkType = resolveLinkType(tracking);

  return {
    trackingProperties,
    customClickTrackValue: getCustomClickTrackValues(trackingProperties, linkType),
  };
};

/** Empty-state How to Earn: prefer AEM empty-state keys, then fall back to section tracking. */
export const resolveWalletEmptyHowToEarnTracking = (
  typeSpecificEmptyTracking?: CommonTrackingConfig,
  sharedEmptyTracking?: CommonTrackingConfig | CommonTrackingConfig[],
  sectionTracking?: CommonTrackingConfig,
  emptyTrackingKeyValue?: string
) =>
  resolveWalletEmbeddedTracking(
    resolveTrackingConfig(typeSpecificEmptyTracking, emptyTrackingKeyValue) ??
      resolveTrackingConfig(sharedEmptyTracking, emptyTrackingKeyValue) ??
      sectionTracking
  );
